import script from "./_pp-draw-results.vue?vue&type=script&lang=ts&setup=true"
export * from "./_pp-draw-results.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__